import {
    FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_FETCHING,
    FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_SUCCESS,
    FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_FAIL,
    SET_MENSTRUAL_CYCLE_SYMPTOM,
    RESET_MENSTRUAL_CYCLE_SYMPTOMS,
    UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_SUCCESS,
    UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_START,
    UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_ERROR,
    MENSTRUAL_CYCLE_SYMPTOMS_ICONS_FETCHING,
    MENSTRUAL_CYCLE_SYMPTOMS_ICONS_SUCCESS,
    MENSTRUAL_CYCLE_SYMPTOMS_ICONS_ERROR,
    MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_FETCHING,
    MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_SUCCESS,
    MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_ERROR,
    SAVE_OR_CONFIRM_SINGLE_CYCLE_START,
    SAVE_OR_CONFIRM_SINGLE_CYCLE_FAIL
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    menstrualCycleDayView: {
        dayLog: null,
        daySummary: null
    },
    menstrualCycleDayViewNoContentStatus: false,
    initialMenstrualCycleDayView: {
        dayLog: null,
        daySummary: null
    },
    menstrualCycleDailyLogFetching: false,
    menstrualCycleDailyLogFetchFail: false,
    menstrualCycleSymptomsUpdating: false,
    menstrualCycleSymptomsUpdatingFail: false,
    menstrualCycleSymptomsIconsFetching: false,
    menstrualCycleSymptomsIconsFetchFail: false,
    saveOrConfirmSingleCycleStart: false,
    saveOrConfirmSingleCycleFail: false,
    menstrualCycleSymptoms: {},
    symptomsIcons: {},
    educationalContent: null
};

const possibleData = {
    flow: ['LIGHT', 'MEDIUM', 'HEAVY'],
    symptoms: [
        'ACNE',
        'BACKACHE',
        'BLOATING',
        'BODY_ACHES',
        'CONSTIPATION',
        'CONTRACTIONS',
        'CRAMPS',
        'CRAVINGS',
        'DIARRHEA',
        'DIZZINESS',
        'FATIGUE',
        'HEADACHE',
        'INSOMNIA',
        'NAUSEA',
        'TENDER_BREASTS',
        'TROUBLE_BREATHING',
        'VOMITING',
        'SWELLING',
        'HEARTBURN',
        'ROUND_LIGAMENT_PAIN'
    ],
    menopauseSymptoms: [
        'CHILLS',
        'DISTRACTED',
        'DRY_SKIN',
        'FREQUENT_URINATION',
        'HAIR_LOSS',
        'HOT_FLASHES',
        'NIGHT_SWEATS',
        'URINE_LEAKAGE',
        'VAGINAL_DRYNESS',
        'WEIGHT_GAIN'
    ],
    moods: [
        'FINE',
        'HAPPY',
        'ENERGETIC',
        'MOTIVATED',
        'MOOD_SWINGS',
        'SAD',
        'EMOTIONAL',
        'OVERWHELMED',
        'IRRITABLE',
        'FRUSTRATED',
        'WORRIED'
    ],
    discharge: ['NO_DISCHARGE', 'LIGHT', 'MEDIUM', 'HEAVY', 'CREAMY', 'EGG_WHITE', 'SPOTTING', 'STICKY', 'UNUSUAL'],
    ovulationDay: false,
    sexualActivity: ['PROTECTED', 'UNPROTECTED'],
    sexDrive: ['LOW', 'AVERAGE', 'HIGH']
};

const dayLogSymptomsDataStructureFallback = {
    symptoms: [],
    moods: [],
    discharge: [],
    notes: '',
    flow: '',
    sexDrive: '',
    sexualActivity: '',
    ovulationDay: false
};

const checkForDischarge = 'discharge';
const checkForNoDischargeValue = 'NO_DISCHARGE';

const removeDailyLogReference = (data) => {
    return {
        ...data,
        dayLog: {
            ...data.dayLog,
            /*can be received as null and not empty arrays or empty strings from the backend - must fall back to defaults*/
            symptoms: data.dayLog.symptoms
                ? [...data.dayLog.symptoms]
                : [...dayLogSymptomsDataStructureFallback.symptoms],
            moods: data.dayLog.moods ? [...data.dayLog.moods] : [...dayLogSymptomsDataStructureFallback.moods],
            discharge: data.dayLog.discharge
                ? [...data.dayLog.discharge]
                : [...dayLogSymptomsDataStructureFallback.discharge],
            notes: data.dayLog.notes ? data.dayLog.notes : dayLogSymptomsDataStructureFallback.notes,
            flow: data.dayLog.flow ? data.dayLog.flow : dayLogSymptomsDataStructureFallback.flow,
            sexDrive: data.dayLog.sexDrive ? data.dayLog.sexDrive : dayLogSymptomsDataStructureFallback.sexDrive,
            sexualActivity: data.dayLog.sexualActivity
                ? data.dayLog.sexualActivity
                : dayLogSymptomsDataStructureFallback.sexualActivity,
            ovulationDay: data.dayLog.ovulationDay ? data.dayLog.ovulationDay : !!data.dayLog.ovulationDay
        }
    };
};

const menstrualCycleDailyLogFetching = (state) => {
    return {
        ...state,
        menstrualCycleSymptoms: INITIAL_STATE.menstrualCycleSymptoms,
        menstrualCycleDailyLogFetching: true,
        menstrualCycleDailyLogFetchFail: false
    };
};

const menstrualCycleDailyLogFetchFinished = (isSuccess) => (state, action) => {
    let menstrualCycleDailyLogVerified =
        action.menstrualCycleDayView && action.menstrualCycleDayView.dayLog
            ? action.menstrualCycleDayView
            : {
                  ...action.menstrualCycleDayView,
                  dayLog: dayLogSymptomsDataStructureFallback
              };

    return {
        ...state,
        /*could use JSON.parse(JSON.stringify(menstrualCycleDailyLogVerified)) instead of removeDailyLogReference*/
        menstrualCycleDayView: removeDailyLogReference(menstrualCycleDailyLogVerified),
        menstrualCycleDayViewNoContentStatus: action.menstrualCycleDayViewStatus === 204,
        initialMenstrualCycleDayView: removeDailyLogReference(menstrualCycleDailyLogVerified),
        menstrualCycleSymptoms: {
            ...state.menstrualCycleSymptoms
        },
        menstrualCycleDailyLogFetching: false,
        menstrualCycleDailyLogFetchFail: !isSuccess
    };
};

const setMenstrualCycleSymptom = (state, action) => {
    let dayLog = {
        ...state.menstrualCycleDayView.dayLog
    };
    if (typeof dayLog[action.key] === 'object' && dayLog[action.key] !== null && dayLog[action.key].length >= 0) {
        if (
            action.key === checkForDischarge &&
            (dayLog[action.key].indexOf(checkForNoDischargeValue) !== -1 || action.value === checkForNoDischargeValue)
        ) {
            if (
                dayLog[action.key].indexOf(checkForNoDischargeValue) !== -1 &&
                action.value === checkForNoDischargeValue
            ) {
                //handle remove of no discharge
                dayLog[action.key].splice(dayLog[action.key].indexOf(action.value), 1);
            } else if (action.value === checkForNoDischargeValue) {
                //handle no discharge add
                dayLog[action.key] = [action.value];
            } else if (
                action.value !== checkForNoDischargeValue &&
                dayLog[action.key].indexOf(checkForNoDischargeValue) === -1
            ) {
                //handle add symptom when no discharge
                dayLog[action.key].push(action.value);
            }
        } else {
            if (dayLog[action.key].indexOf(action.value) !== -1) {
                dayLog[action.key].splice(dayLog[action.key].indexOf(action.value), 1);
            } else {
                dayLog[action.key].push(action.value);
            }
        }
    } else if (typeof dayLog[action.key] === 'string') {
        if (dayLog[action.key].indexOf(action.value) === 0 && action.value === dayLog[action.key]) {
            dayLog[action.key] = '';
        } else {
            dayLog[action.key] = action.value;
        }
    } else if (typeof dayLog[action.key] === 'boolean') {
        dayLog[action.key] = action.value;
    }

    return {
        ...state,
        menstrualCycleDayView: {
            ...state.menstrualCycleDayView,
            dayLog: dayLog
        }
    };
};

const resetMenstrualCycleSymptoms = (state) => {
    return {
        ...state,
        menstrualCycleDayView: removeDailyLogReference(state.initialMenstrualCycleDayView)
    };
};

const updateUserMenstrualCycleSymptomsStarted = (state) => {
    return {
        ...state,
        menstrualCycleSymptomsUpdating: true,
        menstrualCycleSymptomsUpdatingFail: false
    };
};

const updateUserMenstrualCycleSymptoms = (state, action) => {
    let setStateMenstrualCycleDayLogValue = {
        ...state.menstrualCycleDayView,
        dayLog: {
            ...action.response.data
        }
    };

    return {
        ...state,
        /*could use JSON.parse(JSON.stringify(menstrualCycleDailyLogVerified)) instead of removeDailyLogReference*/
        menstrualCycleDayView: removeDailyLogReference(setStateMenstrualCycleDayLogValue),
        initialMenstrualCycleDayView: removeDailyLogReference(setStateMenstrualCycleDayLogValue),
        menstrualCycleSymptomsUpdating: false,
        menstrualCycleSymptomsUpdatingFail: false
    };
};

const updateUserMenstrualCycleSymptomsError = (state) => {
    return {
        ...state,
        /*could use JSON.parse(JSON.stringify(menstrualCycleDailyLogVerified)) instead of removeDailyLogReference*/
        menstrualCycleDayView: removeDailyLogReference(state.initialMenstrualCycleDayView),
        initialMenstrualCycleDayView: removeDailyLogReference(state.initialMenstrualCycleDayView),
        menstrualCycleSymptomsUpdating: false,
        menstrualCycleSymptomsUpdatingFail: true
    };
};

const fetchingMenstrualCycleSymptomsIcons = (state) => {
    return {
        ...state,
        menstrualCycleSymptomsIconsFetching: true,
        menstrualCycleSymptomsIconsFetchFail: false
    };
};

const saveOrConfirmSingleCycleStart = (state) => {
    return {
        ...state,
        saveOrConfirmSingleCycleStart: true,
        menstrualCycleSymptomsIconsFetchFail: false
    };
};

const saveOrConfirmSingleCycleFail = (state) => {
    return {
        ...state,
        saveOrConfirmSingleCycleStart: false,
        saveOrConfirmSingleCycleFail: true
    };
};

const menstrualCycleSymptomsIconsFetchFail = (state) => {
    return {
        ...state,
        menstrualCycleSymptomsIconsFetching: false,
        menstrualCycleSymptomsIconsFetchFail: true
    };
};

const updateMenstrualCycleSymptomsIcons = (state, action) => {
    return {
        ...state,
        symptomsIcons: {
            ...action.response.data
        },
        menstrualCycleSymptomsIconsFetching: false,
        menstrualCycleSymptomsIconsFetchFail: false
    };
};

const fetchingMenstrualCycleEducationalContent = (state) => {
    return {
        ...state,
        menstrualCycleEducationalContentFetching: true,
        menstrualCycleEducationalContentFetchFail: false
    };
};

const menstrualCycleEducationalContentFetchFail = (state) => {
    return {
        ...state,
        menstrualCycleEducationalContentFetching: false,
        menstrualCycleEducationalContentFetchFail: true
    };
};

const menstrualCycleEducationalContentFetchSuccess = (state, action) => {
    return {
        ...state,
        educationalContent: {
            ...action.response.data
        },
        menstrualCycleEducationalContentFetching: false,
        menstrualCycleEducationalContentFetchFail: false
    };
};

export const isMenstrualCycleDaySummaryEmpty = (state) => {
    return (
        !state.menstrualCycle.menstrualCycleDayView.daySummary ||
        state.menstrualCycle.menstrualCycleDayView.daySummary === null
    );
};

export const getMenstrualCycleDayViewIsNoContentStatus = (state) => {
    return state.menstrualCycle.menstrualCycleDayViewNoContentStatus;
};

export const getMenstrualCycleDailyLog = (state) => {
    return state.menstrualCycle.menstrualCycleDayView.dayLog;
};

export const getMenstrualCycleDaySummary = (state) => {
    return state.menstrualCycle.menstrualCycleDayView.daySummary;
};

export const getMenstrualCycleDailyLogFetchingState = (state) => {
    return state.menstrualCycle.menstrualCycleDailyLogFetching;
};

export const getMenstrualCycleSymptoms = (state) => {
    /*conditional displaying of menstrual symptoms if user has value checked in user settings*/
    let gotUserMenstrualCycleSettings =
        state.userSettings.userSettings && state.userSettings.userSettings.userMenstrualCycleSettings;
    let userSettings = state.userSettings.userSettings;
    /*add flow to symptoms options if currentPhase is 1 (cycle day) and if daySummary is not null */
    let shouldDisplayFlow =
        (state.menstrualCycle.menstrualCycleDayView.daySummary &&
            state.menstrualCycle.menstrualCycleDayView.daySummary.currentPhase === 1) ||
        (state.menstrualCycle.initialMenstrualCycleDayView &&
            state.menstrualCycle.initialMenstrualCycleDayView.dayLog &&
            state.menstrualCycle.initialMenstrualCycleDayView.dayLog.flow);

    state.menstrualCycle.menstrualCycleSymptoms = {
        ...(gotUserMenstrualCycleSettings &&
            userSettings.userMenstrualCycleSettings.flowTracking &&
            shouldDisplayFlow && { flow: possibleData.flow }),
        ...(gotUserMenstrualCycleSettings &&
            userSettings.userMenstrualCycleSettings.physicalSymptomsTracking && { symptoms: possibleData.symptoms }),
        ...(gotUserMenstrualCycleSettings &&
            userSettings.userMenstrualCycleSettings.moodTracking && { moods: possibleData.moods }),
        ...(gotUserMenstrualCycleSettings &&
            userSettings.userMenstrualCycleSettings.dischargeTracking && { discharge: possibleData.discharge }),
        ...(gotUserMenstrualCycleSettings &&
            userSettings.userMenstrualCycleSettings.ovulationDateTracking && {
                ovulationDay: possibleData.ovulationDay
            }),
        ...(gotUserMenstrualCycleSettings &&
            userSettings.userMenstrualCycleSettings.sexualActivityTracking && {
                sexualActivity: possibleData.sexualActivity
            }),
        ...(gotUserMenstrualCycleSettings &&
            userSettings.userMenstrualCycleSettings.sexDriveTracking && { sexDrive: possibleData.sexDrive })
    };

    let showMenopauseSymptoms = gotUserMenstrualCycleSettings
        ? userSettings.userMenstrualCycleSettings.menopauseSymptomsTracking &&
          userSettings.userMenstrualCycleSettings.physicalSymptomsTracking
        : false;

    if (showMenopauseSymptoms) {
        let menstrualCycleSymptomsWithMenopauseSymptoms = [
            ...state.menstrualCycle.menstrualCycleSymptoms.symptoms,
            ...possibleData.menopauseSymptoms
        ].sort();
        state.menstrualCycle.menstrualCycleSymptoms = {
            ...state.menstrualCycle.menstrualCycleSymptoms,
            symptoms: [...menstrualCycleSymptomsWithMenopauseSymptoms]
        };
    }

    return state.menstrualCycle.menstrualCycleSymptoms;
};

export const getMenstrualCycleSymptomsIcons = (state) => {
    return state.menstrualCycle.symptomsIcons;
};

export const getMenstrualCycleEducationalContent = (state) => {
    return state.menstrualCycle.educationalContent;
};

export const isMenstrualCycleSymptomsUpdateFail = (state) => {
    return state.menstrualCycle.menstrualCycleSymptomsUpdatingFail;
};

const handlers = {
    [FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_FETCHING]: menstrualCycleDailyLogFetching,
    [FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_SUCCESS]: menstrualCycleDailyLogFetchFinished(true),
    [FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_FAIL]: menstrualCycleDailyLogFetchFinished(false),
    [SET_MENSTRUAL_CYCLE_SYMPTOM]: setMenstrualCycleSymptom,
    [RESET_MENSTRUAL_CYCLE_SYMPTOMS]: resetMenstrualCycleSymptoms,
    [UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_START]: updateUserMenstrualCycleSymptomsStarted,
    [UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_SUCCESS]: updateUserMenstrualCycleSymptoms,
    [UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_ERROR]: updateUserMenstrualCycleSymptomsError,
    [MENSTRUAL_CYCLE_SYMPTOMS_ICONS_FETCHING]: fetchingMenstrualCycleSymptomsIcons,
    [MENSTRUAL_CYCLE_SYMPTOMS_ICONS_SUCCESS]: updateMenstrualCycleSymptomsIcons,
    [MENSTRUAL_CYCLE_SYMPTOMS_ICONS_ERROR]: menstrualCycleSymptomsIconsFetchFail,
    [MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_FETCHING]: fetchingMenstrualCycleEducationalContent,
    [MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_SUCCESS]: menstrualCycleEducationalContentFetchSuccess,
    [MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_ERROR]: menstrualCycleEducationalContentFetchFail,
    [SAVE_OR_CONFIRM_SINGLE_CYCLE_START]: saveOrConfirmSingleCycleStart,
    [SAVE_OR_CONFIRM_SINGLE_CYCLE_FAIL]: saveOrConfirmSingleCycleFail
};

export default function menstrualCycle(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
